import "alpinejs";

function alertBanner(config) {
	const cookieName = "site-alert-" + config.id;

	function getCookie(name) {
		const matches = document.cookie.match(
			new RegExp("(^| )" + name + "=([^;]+)")
		);
		return matches && matches[2];
	}

	function setCookie(name, value, days) {
		var data = new Date();
		data.setDate(data.getDate() + days);
		document.cookie =
			name +
			"=" +
			escape(value) +
			(days == null ? "" : "; expires=" + data.toUTCString());
	}

	return {
		show: false,
		init() {
			this.show = getCookie(cookieName) !== "true";
		},
		hide() {
			setCookie(cookieName, "true", 30);
			this.close();
		},
		close() {
			this.show = false;
		},
	};
}

function nestedMenu() {
	return {
		active: [],
		isActive(id) {
			return this.active[this.active.length - 1] === id;
		},
		hasChildOpen(id) {
			if (typeof id === "undefined") {
				return this.active.length > 0;
			}
			return this.isActive(id) && this.active[this.active.length - 1] !== id;
		},
		pop() {
			this.active.pop();
		},
		push(id) {
			const menuElement = this.$refs.menu;
			if (menuElement && menuElement.parentNode) {
				// Scroll to the top of the menu element.
				menuElement.parentNode.scrollTop = 0;
			}
			this.active.push(id);
		},
	};
}

function pageData() {
	let searchMounted = false;
	let searchAppRoot = document.getElementById("search-app-root");

	return {
		searchOpen: false,
		showSearch() {
			if (!searchMounted) {
				
				window.mountSearchApp(searchAppRoot);
				searchMounted = true;
			}
			this.searchOpen = true;

			let searchInput = searchAppRoot.querySelector("input[type=search]");
			if (searchInput) {
				window.setTimeout(() => {
					searchInput.focus();
				}, 0);
			}
		},
		panelOpen() {
			return this.searchOpen;
		},
		closePanels() {
			this.searchOpen = false;
		},
	};
}

window.nestedMenu = nestedMenu;
window.alertBanner = alertBanner;
window.pageData = pageData;
